export const SET_TELEGRAM_NEW_DIALOG_VISIBLE = 'SET_TELEGRAM_NEW_DIALOG_VISIBLE';
export const SET_TELEGRAM_SELECTED_COUNTRY = 'SET_TELEGRAM_SELECTED_COUNTRY';

export const REQUEST_TELEGRAM_CODE_REQUEST = 'REQUEST_TELEGRAM_CODE_REQUEST';
export const REQUEST_TELEGRAM_CODE_SUCCESS = 'REQUEST_TELEGRAM_CODE_SUCCESS';
export const REQUEST_TELEGRAM_CODE_FAILURE = 'REQUEST_TELEGRAM_CODE_FAILURE';

export const SIGN_IN_TELEGRAM_REQUEST = 'SIGN_IN_TELEGRAM_REQUEST';
export const SIGN_IN_TELEGRAM_SUCCESS = 'SIGN_IN_TELEGRAM_SUCCESS';
export const SIGN_IN_TELEGRAM_FAILED = 'SIGN_IN_TELEGRAM_FAILED';

export const REGISTER_TELEGRAM_REQUEST = 'REGISTER_TELEGRAM_REQUEST';
export const REGISTER_TELEGRAM_SUCCESS = 'REGISTER_TELEGRAM_SUCCESS';
export const REGISTER_TELEGRAM_FAILED = 'REGISTER_TELEGRAM_FAILED';



// WEBPACK FOOTER //
// ./src/store/modules/telegram/mutation-types.js